import React from 'react'

function FliterOptions(props) {
  const {
    // DropDownsDisable,
    onSearchingFilterDropDownsDisable,
    dropDownMovieAndPerson,
    dropDownUserAndEdit,
    filterButton,
    resetButton,
    movieAndPersonValue,
    UserAndEditValue,
    filterDisable,
    status,
    setStatus,
    SetFilterValue,
    // setFilterDisable,
  } = props
  // console.log(
  //   filterDisable,
  //   onSearchingFilterDropDownsDisable,
  //   // DropDownsDisable,
  //   'onSearchingFilterDropDownsDisable',
  // )
  const selectStatus = event => {
    setStatus(event.target.value)
    SetFilterValue('movieListCategory')
  }

  return (
    <>
      <div>
        <div className='d-flex' style={{ gap: '3%' }}>
          <div className='d-flex flex-column'>
            <lable className='mb-2'>
              <b>movieListCategory</b>
            </lable>
            <select
              disabled={onSearchingFilterDropDownsDisable}
              onChange={dropDownMovieAndPerson}
              value={movieAndPersonValue}
              required
              name='select'
              id='languages'
            >
              <option value='' disabled selected>
                movieListCategory
              </option>
              <option value='Movie'>Movie</option>
              <option value='Person'>Person</option>
              <option value='Text'>Text</option>
            </select>
          </div>
          <div className='d-flex flex-column'>
            <lable className='mb-2'>
              <b>movieListType</b>
            </lable>
            <select
              disabled={onSearchingFilterDropDownsDisable}
              onChange={dropDownUserAndEdit}
              value={UserAndEditValue}
              required
              name='select'
              id='languages'
            >
              <option value='' disabled selected>
                movieListType
              </option>
              <option value='User'>User</option>
              <option value='Editorial'>Editorial</option>
            </select>
          </div>
          <div>
            <button
              disabled={filterDisable || onSearchingFilterDropDownsDisable}
              className='btn btn-primary m-2 '
              onClick={filterButton}
            >
              Filter
            </button>
            <button
              disabled={onSearchingFilterDropDownsDisable}
              className='btn btn-primary'
              onClick={resetButton}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
      <div style={{ width: '40%' }}>
        <label>Status:</label>
        <select
          className='form-select'
          aria-label='Default select example'
          onChange={e => selectStatus(e)}
        >
          <option selected={status === 'published'} value='published'>
            published
          </option>

          <option selected={status === 'draft'} value='draft'>
            Draft
          </option>
        </select>
      </div>
    </>
  )
}

export default FliterOptions
